import { Component, Input } from '@angular/core';
import { IBallotHistoryItem } from '../../models/ballot-base/ballot-history-item';
import { ITableColumn, TableColumnType } from '../../../../controls/table/table-column';

@Component({
    selector: 'app-ballot-history',
    templateUrl: './ballot-history.component.html',
    styleUrl: './ballot-history.component.scss',
    standalone: false
})
export class BallotHistoryComponent {
  @Input() id: string = 'ballotHistoryTable';
  @Input() ballotHistoryItems: IBallotHistoryItem[] = [];

    ballotHistoryColumns: ITableColumn<IBallotHistoryItem>[] = [
    {
      name: 'eventDate',
      displayName: 'Date',
      type: TableColumnType.date,
      isSortable: false
    },
    {
      name: 'fullName',
      displayName: 'Name',
      type: TableColumnType.string,
      isSortable: false
    },
    {
      name: 'reviewStageDisplayText',
      displayName: 'Review Stage',
      type: TableColumnType.string,
      isSortable: false
    },
    {
      name: 'reviewOutcomeDisplayText',
      displayName: 'Outcome',
      type: TableColumnType.string,
      isSortable: false
    },
    {
      name: 'unifiedBallotStatusDisplayText',
      displayName: 'Status',
      type: TableColumnType.string,
      isSortable: false
    },
    {
      name: 'comment',
      displayName: 'Comments',
      type: TableColumnType.string,
      isSortable: false
    },
  ];
}
